import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Manager, Target, Popper } from 'react-popper';
import Button from 'material-ui/Button';
import ClickAwayListener from 'material-ui/utils/ClickAwayListener';
import Collapse from 'material-ui/transitions/Collapse';
import Portal from 'material-ui/Portal';
import { MenuItem, MenuList } from 'material-ui/Menu';
import { withStyles } from 'material-ui/styles';
import ArrowDropdown from '../Icons/ArrowDropdown';

const styles = () => ({
  root: {
    display: 'flex',
  },
  popperClose: {
    pointerEvents: 'none',
  },
  btn: {
    fontSize: 13,
  },
  btnOpened: {
    color: 'inherit',
  },

  item: {
    fontSize: 13,
    borderBottom: '1px solid #D8DBDF',
    '&:hover': {
      backgroundColor: 'rgba(26,101,255,.05)',
    }
  },

  itemSelected: {
    color: '#6F9EFF',
    background: '#F2F6FF',
  },

  dropdown: {
    margin: 12,
    background: '#FFFFFF',
    border: '1px solid #D8DBDF',
    boxShadow: '0 4px 8px rgba(0,0,0,.12)',
  },

  newLabel: {
    fontWeight: "bold",
    fontSize: "10px",
    background: "#FFC62B",
    color: "#FFFFFF",
    padding: "3px 6px",
    marginLeft: "5px",
    whiteSpace: "nowrap",
    borderRadius: "3px",
    lineHeight: 'normal',
  },
});

class DropdownMenu extends React.Component {
  state = {
    open: false,
  };

  handleToggle = event => {
    if (this.props.onClick) this.props.onClick();
    this.setState({ open: !this.state.open });
    event.stopPropagation();
  };

  handleClose = event => {
    if (this.target.contains(event.target)) {
      return;
    }

    this.setState({ open: false });
  };

  handleClick = (action, itemName) => {
    return (event) => {
      event.stopPropagation();
      action(event); // eventをactionに渡す

      // ヘッダーのユーザー選択で「もっと見る...」がクリックされた場合はメニューを閉じない
      if (itemName !== 'もっと見る...') {
        this.setState({ open: false });
      }
    }
  }

  createMenuItems = () => {
    const { classes, selected } = this.props;
    let menuItems = [];
    let items = this.props.menuItems;
    for (var i = 0; i < items.length; i++) {
      if (i === items.length - 1) {
        menuItems.push(
          <MenuItem
            onClick={this.handleClick(items[i].func, items[i].name)} key={i}
            className={items[i].name === selected ? classes.itemSelected : classes.item}
            style={{ border: 'none', color: items[i].name === 'もっと見る...' ? '#71737B' : '#181819' }}
          >
            {items[i].name} {items[i].isNew && <div className={classes.newLabel}>NEW</div>}
          </MenuItem>);
      } else {
        menuItems.push(
          <MenuItem
            onClick={this.handleClick(items[i].func, items[i].name)}
            key={i}
            className={items[i].name === selected ? classes.itemSelected : classes.item}>
            {items[i].name} {items[i].isNew && <div className={classes.newLabel}>NEW</div>}
          </MenuItem>);
      }
    }
    return menuItems;
  }

  render() {
    const { classes } = this.props;
    const { open } = this.state;

    return (
      <div className={classes.root}>
        <Manager>
          <Target>
            <div
              ref={node => {
                this.target = node;
              }}
            >
              <Button
                aria-owns={open ? 'menu-list-collapse' : null}
                aria-haspopup="true"
                onClick={this.handleToggle}
                className={classNames(classes.btn, { [classes.btnOpened]: open })}
                style={{ color: this.props.type === "dark" ? "#FFFFFF" : "" }}
                disabled={this.props.disabled}
              >
                {this.props.menuTitle ? this.props.menuTitle : this.props.children}
                {this.props.dropdownIcon ? <ArrowDropdown color={this.props.type === "dark" ? "#FFFFFF" : "#71737B"} width={20} height={20} style={{ paddingLeft: '8px' }} /> : undefined}
              </Button>
            </div>
          </Target>
          <Portal>
            <Popper
              placement={this.props.popperPlacement}
              eventsEnabled={open}
              className={classNames({ [classes.popperClose]: !open })}
              style={{ zIndex: 1000 }}
            >
              <ClickAwayListener onClickAway={this.handleClose}>
                <Collapse in={open} id="menu-list-collapse" style={{ transformOrigin: '0 0 0' }}>
                  <div className={classes.dropdown}>
                    <MenuList role="menu" style={{ padding: 0 }}>
                      {this.createMenuItems()}
                    </MenuList>
                  </div>
                </Collapse>
              </ClickAwayListener>
            </Popper>
          </Portal>
        </Manager>
      </div>
    );
  }
}

DropdownMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  menuItems: PropTypes.array,
  menuTitle: PropTypes.string,
  dropdownIcon: PropTypes.bool,
  popperPlacement: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  selected: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
};

DropdownMenu.defaultProps = {
  dropdownIcon: false,
  popperPlacement: 'bottom',
}

export default withStyles(styles)(DropdownMenu);



// WEBPACK FOOTER //
// ./src/components/common/DropdownMenu.jsx